// This is your live Railway backend URL
const PUBLIC_BACKEND_URL = 'https://smartedzweb-production.up.railway.app';

// This URL is for static files like images (if you need them)
export const SERVER_URL = PUBLIC_BACKEND_URL; 

// This URL is for your API calls
export const API_BASE_URL = `${PUBLIC_BACKEND_URL}/api`;